/**
 * 財務區共用日期區間 store
 *
 * - 跨 tab 記憶（sessionStorage，關閉 tab 重置）
 * - 月份口徑頁面用 `period`（從 start 推導）
 * - 區間口徑頁面用 `start` / `end`
 */
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface FinancialDateRangeState {
  start: string; // YYYY-MM-DD
  end: string;   // YYYY-MM-DD
  setRange: (start: string, end: string) => void;
  setMonth: (period: string) => void; // YYYY-MM
}

const pad = (n: number) => String(n).padStart(2, "0");

function thisMonthRange(): { start: string; end: string } {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  return {
    start: `${y}-${pad(m + 1)}-01`,
    end: `${y}-${pad(m + 1)}-${pad(new Date(y, m + 1, 0).getDate())}`,
  };
}

const initial = thisMonthRange();

export const useFinancialDateRange = create<FinancialDateRangeState>()(
  persist(
    (set) => ({
      start: initial.start,
      end: initial.end,
      setRange: (start, end) => set({ start, end }),
      setMonth: (period) => {
        const [y, m] = period.split("-").map(Number);
        const start = `${y}-${pad(m)}-01`;
        const end = `${y}-${pad(m)}-${pad(new Date(y, m, 0).getDate())}`;
        set({ start, end });
      },
    }),
    {
      name: "onreel-financial-date-range",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (s) => ({ start: s.start, end: s.end }),
    }
  )
);

/** 從 start 推導出 YYYY-MM 月份字串 */
export function periodFromRange(start: string): string {
  return start.slice(0, 7);
}
